import React, { useEffect, useState } from 'react'
import {
  Edit,
  SimpleForm,
  TextInput,
  useTranslate,
  useEditController,
  useNotify,
  useRedirect,
  required,
} from 'react-admin'
import { Grid, Skeleton } from '@mui/material'
import { CardCommon } from 'src/components/uiElements'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { applicationServices } from 'src/services/auth/application/application.service'
import { clientServices } from 'src/services/auth/client/client.service'
import { CardCrudBottomButtons } from 'src/components/uiElements/CRUD/CardCrudBottomButtons'
import { isJsonValidate } from 'src/helper/validatorJson'
import { SelectInput } from 'src/components/uiElements/fields/SelectInput'

export const ProcessApplicationEdit = (props) => {
  const translate = useTranslate()
  const notify = useNotify()
  const redirect = useRedirect()
  const [clients, setClients] = useState([])
  const [loadingClients, setLoadingClients] = useState(false)
  const [applications, setApplications] = useState([])
  const [loadingApplications, setLoadingApplications] = useState(false)
  const { record } = useEditController({ resource: 'processApplication', id: props.id })

  useEffect(() => {
    if (record) {
      getAllClient()
      getApplicationByClient(record.client_id)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [record])

  const getAllClient = async () => {
    setLoadingClients(true)
    try {
      const allClients = await clientServices.getByAll()
      setClients(allClients)
      setLoadingClients(false)
    } catch (error) {
      notify(`please, refresh page`, { type: 'error' })
      setLoadingClients(false)
    }
  }

  const getApplicationByClient = async (idClient) => {
    if (idClient) {
      try {
        setLoadingApplications(true)
        let allApplications = await applicationServices.getApplicationByClient(idClient)
        setApplications(allApplications.map((item) => item.application))
        setLoadingApplications(false)
      } catch (error) {
        notify(`applications not found`, { type: 'error' })
        setLoadingApplications(false)
        return
      }
    }
  }

  const onSuccess = () => {
    notify('ra.notification.updated_success_masculine', {
      type: 'success',
      messageArgs: { element: translate('ra.single_entity.processApplication') }
    })
    redirect('/processApplication')
  }

  const onError = () => {
    notify('ra.notification.updated_error_masculine', {
      type: 'error',
      messageArgs: { element: translate('ra.single_entity.processApplication') }
    })
  }
  const transform = (data) => {
    return {
      endpoint: data.endpoint,
      application_id: data.application_id,
      client_id: data.client_id,
      steps: data.steps,
    }
  }

  return (
    <Edit {...props} mutationMode='pessimistic' mutationOptions={{ onSuccess, onError }} actions={null} transform={transform}>
      <CardCommon title={translate('ra.title.update_processApplication')}>
        <SimpleForm
          toolbar={<CardCrudBottomButtons btnSave={true} btnDelete={true} fieldsName={['short_name']} genderElement='masculine' />}
        >
          <Grid container spacing={3}>
            <EditInputsWrap label={translate('ra.field.id')}>
              <TextInput disabled source='id' label='' fullWidth />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.endpoint')} required>
              <TextInput source='endpoint' label='' fullWidth validate={[required()]} />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.client')} required>
              {loadingClients ? (
                <Skeleton variant='rectangular' width={'100%'} height={40} />
              ) : (
                <SelectInput
                  source='client_id'
                  optionsText={['long_name']}
                  label=''
                  fullWidth
                  options={clients}
                  defaultValue={record?.client_id}
                  validate={[required()]}
                  onChange={(e) => getApplicationByClient(e.target.value)}
                  disabled
                />
              )}
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.application')} required>
              {loadingApplications ? (
                <Skeleton variant='rectangular' width={'100%'} height={40} />
              ) : (
                <SelectInput
                  source='application_id'
                  optionsText={['long_name']}
                  options={applications}
                  defaultValue={record?.application_id}
                  label=''
                  fullWidth
                  validate={[required()]}
                />
              )}
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.steps')}>
              <TextInput
                source='steps'
                label={false}
                multiline
                rows={5}
                fullWidth
                validate={isJsonValidate}
                format={(v) => {
                  return typeof v === 'object' ? JSON.stringify(v) : v
                }}
                parse={(v) => {
                  try {
                    return (v && v.length >= 2) ? JSON.parse(v) : v
                  } catch (e) {
                    return v || undefined
                  }
                }}
              />
            </EditInputsWrap>
          </Grid>
        </SimpleForm>
      </CardCommon>
    </Edit>
  )
}
